import { supabase } from "@/integrations/supabase/client";

export type CoachPublic = {
  user_id: string;
  headline: string;
  bio: string;
  specialties: string[];
  booking_url: string;
  hourly_rate_cents: number | null;
  display_name: string | null;
  avatar_url: string | null;
  selected_pillar: string | null;
  current_badge_tier: string | null;
};

export type StoryPublic = {
  user_id: string;
  quote: string | null;
  display_mode: string;
  featured: boolean;
  display_name: string | null;
  avatar_url: string | null;
  selected_pillar: string | null;
  current_badge_tier: string | null;
  total_impact_cents: number;
};

export async function fetchActiveCoaches(pillar?: string): Promise<CoachPublic[]> {
  let q = (supabase as any).from("active_coaches_public").select("*");
  if (pillar) q = q.eq("selected_pillar", pillar);
  const { data, error } = await q.limit(60);
  if (error) throw error;
  return (data ?? []) as CoachPublic[];
}

export async function fetchPublishedStories(opts?: { pillar?: string; featuredOnly?: boolean; limit?: number }): Promise<StoryPublic[]> {
  let q = (supabase as any).from("published_stories_public").select("*");
  if (opts?.pillar) q = q.eq("selected_pillar", opts.pillar);
  if (opts?.featuredOnly) q = q.eq("featured", true);
  q = q.order("total_impact_cents", { ascending: false }).limit(opts?.limit ?? 60);
  const { data, error } = await q;
  if (error) throw error;
  return (data ?? []) as StoryPublic[];
}
